
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { MatchNode } from "@/lib/model/exambuilder/exam-component/application-rule";
import { ruleStore } from "@/store/rules";
import { findNode, findPath } from "../../utils/treeHelper";

@Component({
  name: "RuleFormItem"
})
export default class RuleFormItem extends Vue {
  @Prop({ type: String, default: "" }) prefix!: string;
  @Prop({ type: Object, required: true }) formData!: MatchNode;
  @Prop({ type: String, default: "AND" }) type!: string;
  @Prop({ type: Boolean, default: false }) readonly!: boolean;
  cascaderValue = [];

  get relations() {
    if (!this.formData.detail?.attrKey) return [];
    return ruleStore.attrRelations[this.currentKey];
  }

  get enums() {
    if (!this.formData.detail?.attrKey) return [];
    return ruleStore.attrEnums[this.currentKey];
  }

  get currentKey() {
    return this.cascaderValue[this.cascaderValue.length - 1];
  }

  get levels() {
    if (!this.formData.detail?.attrKey) return [];
    return ruleStore.attrLevels[this.currentKey];
  }

  get allAttrs() {
    return ruleStore.allAttrs;
  }

  getValueProp(relKey?: string): string {
    const params = this.relations.find((item: any) => item.relKey === relKey);
    return params?.valueNeed ?? "";
  }

  getRealValueProp(relKey?: string): string {
    const params = this.relations.find((item: any) => item.relKey === relKey);
    if (!params?.valueNeed) return "";
    if (params.valueNeed === "stringParamOption") return "string";
    if (params.valueNeed === "stringParamOptions") return "strings";
    return params.valueNeed;
  }

  handleAdd() {
    this.formData.subList?.push({
      detail: {}
    });
  }

  handleChange(value: string[]) {
    const val = value[value.length - 1];
    const result = findNode(this.allAttrs, node => {
      return node.value === val;
    });
    if (this.formData.detail) {
      if (result.params) {
        for (const key in result.params) {
          this.$set(this.formData.detail, key, result.params[key]);
        }
      } else {
        for (const key in this.formData.detail) {
          this.$set(this.formData.detail, key, undefined);
        }
        this.$set(this.formData.detail, "attrKey", val);
      }
    }
  }

  handleChangeRel() {
    if (!this.formData.detail) return;
    this.$set(this.formData.detail, "string", undefined);
    this.$set(this.formData.detail, "strings", undefined);
    this.$set(this.formData.detail, "enum", undefined);
    this.$set(this.formData.detail, "enums", []);
    this.$set(this.formData.detail, "number", undefined);
    this.$set(this.formData.detail, "level", undefined);
    this.$set(this.formData.detail, "levels", []);
  }

  private handleMouseEnter(e: MouseEvent) {
    if (this.formData.subList!.length <= 1) return;
    (e.target as HTMLElement).classList.add("inner-err-active");
  }

  private handleMouseLeave(e: MouseEvent) {
    (e.target as HTMLElement).classList.remove("inner-err-active");
  }

  @Watch("formData.detail.attrKey", { immediate: true })
  changeAttrKey() {
    if (!this.formData.detail) return;
    let key = this.formData.detail.attrKey;
    for (const item in this.formData.detail) {
      const val = (this.formData.detail as any)[item];
      if (
        [
          "questionId",
          "paramName",
          "dimensionKey",
          "dimensionGroupName"
        ].includes(item) &&
        val
      ) {
        key = `${key}-${val}`;
      }
    }
    const result = findPath(
      this.allAttrs,
      node => {
        return node.value === key;
      },
      {
        children: "children",
        id: "value"
      }
    );
    if (result) {
      this.cascaderValue = result.map((item: any) => item.value);
    } else {
      this.cascaderValue = [];
    }
  }
}
